<template>
  <modalWindow
    v-if="messaging"
    @close="clearMessage();messaging=false; selectedBrand = null;"
    width="600"
    overflow="hidden"
  >
    <div class="titlebar">Bericht plaatsen</div>
    <div v-if="msg.msg" :class="['form-' + msg.type]">{{ msg.msg }}</div>
    <form @submit.prevent class="inset">
      <div class="message-row">
        <inputDropdown
          :array="types"
          v-model="typeDropdownValue"
          displayPrefix="E-mail type: "
          :transparent="true"
          :class="{ 'nobrand': !contents }"
        />
        <inputDropdown
          v-if="contents"
          :array="content"
          v-model="contentDropdownValue"
          displayPrefix="Bericht inhoud: "
          :transparent="true"
          :cb="contentDropdownCB"
        />
      </div>
      <div class="message-row">
        <input
          type="text"
          ref="messageTitle"
          placeholder="Titel"
          :class="{ 'nobrand': brand }"
        />
        <inputDropdown
          v-if="!brand"
          :array="brands"
          v-model="selectedBrand"
          displayPrefix="Merk: "
          :transparent="true"
        />
      </div>
      <textarea rows="8" ref="message" placeholder="Bericht"></textarea>
      <input type=hidden ref="messageUser" placeholder="Iedereen">
      <input type=submit @click="sendMessage" value="Bericht plaatsen/e-mail versturen">
    </form>
  </modalWindow>
</template>

<script>
export default {
  name: 'MessageUser',
  data() {
    return {
      dropdownlist: false,
      dropdownlistBrand: false,
      selectedBrand: null,
      messaging: false,
      msg: { msg: null, type: 'notice' },
      contentDropdownValue: 0,
      content: [
        {
          label: 'Zelf',
          value: 0,
        },
        {
          label: 'Gegevens bijhouden',
          value: 1,
        },
      ],
      typeDropdownValue: 0,
      types: [
        {
          label: 'actie niet-vereist',
          value: 0,
        },
        {
          label: 'actie wel-vereist',
          value: 2,
        },
      ],
      brands: [
        { label: 'Huidige omgeving', value: null },
        { label: 'Doelbeleggen', value: 'Doelbeleggen' },
        { label: 'OXBY', value: 'OXBY' },
        { label: 'Velthuyse • Mulder', value: 'VMVB' },
        { label: 'Beer & Van Stapele', value: 'BVS' },
      ],
    };
  },
  props: {
    contents: {
      default: false,
      type: Boolean,
    },
    brand: {
      default: null,
      type: String,
    },
  },
  created() {
    this.selectedBrand = this.brand;
  },
  methods: {
    contentDropdownCB() {
      switch (this.contentDropdownValue) {
        case 0:
          this.$refs.messageTitle.value = '';
          this.$refs.message.value = '';
          break;
        case 1:
          this.$refs.messageTitle.value = this.content[this.contentDropdownValue].label;
          this.$refs.message.value = 'Wij vragen even van uw tijd om het klantprofiel dat voor u klaarstaat na '
            + 'te lopen.<br><br>\n\n'
            + 'Het is belangrijk dat uw vermogen wordt belegd op de manier die bij u past. Welke manier '
            + 'dat is, hangt af van uw gegevens. Daarom vragen wij u van tijd tot tijd naar '
            + 'veranderingen of te kijken naar een nieuwe vraag die is toegevoegd.<br><br>\n\n'
            + 'Alvast bedankt!<br><br>\n\n'
            + 'Met vriendelijke groet,<br>\n'
            + `Team ${this.brand}`;
          break;
        default:
          break;
      }
    },
    clearMessage() {
      this.msg = { msg: null, type: 'notice' };
    },
    sendMessage() {
      if (this.$refs.messageTitle.value && this.$refs.message.value) {
        this.sdk.createMessage(
          this.$refs.messageUser.value,
          this.$refs.messageTitle.value,
          this.$refs.message.value,
          0,
          this.typeDropdownValue,
          () => {},
          this.selectedBrand || this.brand,
        );
        this.messaging = false;
      } else {
        this.msg = { msg: 'Vul alles in!', type: 'error' };
      }
    },
    userMessage(user, title = '') {
      this.messaging = true;
      this.$nextTick(() => {
        this.$refs.messageUser.value = user;
        this.$refs.messageTitle.value = title;
        this.$refs.message.focus();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  form {
    padding: 10px;

    .message-row {
      .inputDropdown {
        width: calc(50% - 5px);
        background-color: #ffffff;

        &.nobrand {
          width: 100%;
        }
      }

      input[type="text"] {
        width: calc(50% - 5px);
        margin-top: 0;

        &.nobrand {
          width: 100%;
        }
      }

      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    input,
    button,
    textarea {
      border-radius: 0;
    }

    textarea {
      min-height: 80px;
      max-height: 60vh;
      margin-top: 0 !important;
    }
  }
</style>
